<div class="table-responsive gung-responsive">
  <table class="table table-borderless table-striped">
    <thead>
      <tr>
        <th translate>ID</th>
        <th translate>NAME</th>
        <th translate>GROUP</th>
        <th translate>LAST_REPORTED_STATUS</th>
        <th translate>START_TIME</th>
        <th translate>END_TIME</th>
        <th translate>EXECUTION_TIME</th>
        <th translate>STATUS</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of data">
        <td [attr.data-label]="'ID' | translate">
          {{ item.jobInstanceId }}
        </td>
        <td [attr.data-label]="'NAME' | translate">
          {{ item.jobName }}
        </td>
        <td [attr.data-label]="'GROUP' | translate" translate>
          {{ item.jobGroup }}
        </td>
        <td [attr.data-label]="'LAST_REPORTED_STATUS' | translate">
          {{ item.lastReportedStatus }}
        </td>
        <td [attr.data-label]="'START_TIME' | translate">
          {{ item.startTime | date: dateUtilService.dateTimeFormat }}
        </td>
        <td [attr.data-label]="'END_TIME' | translate">
          {{ item.endTime | date: dateUtilService.dateTimeFormat }}
         </td>
        <td [attr.data-label]="'EXECUTION_TIME' | translate">
          {{ item.executionTime }}
        </td>
        <td [attr.data-label]="'STATUS' | translate">
          {{ item.status }}
        </td>
        <td>
          <button
            *ngIf="item.exception"
            type="button"
            class="btn btn-link"
            (click)="showLastExceptionTrace(item, content)"
          >
            <i class="fas fa-question-circle"></i>
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<ng-template #content let-modal>
  <div class="modal-header">
    <div>
      <h4 class="modal-title" id="modal-basic-title">{{ lastException?.jobName }} - Exception details</h4>
      <span>{{ lastException?.lastExceptionDate | date: 'yyyy-MM-dd HH:mm' }}</span>
    </div>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <pre>
      {{ lastException?.lastExceptionTrace }}
    </pre>
  </div>
  <div class="modal-footer"></div>
</ng-template>
